/// <reference types="@angular/localize" />
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { registerLocaleData } from '@angular/common';
import localeEsCo from '@angular/common/locales/es-CO';

import { AppModule } from './app/app.module';

registerLocaleData(localeEsCo, 'es-CO');

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

  